import React from 'react';
import {
  Container,
  Typography,
  Paper,
  Box,
  Divider
} from '@mui/material';

const PrivacyPolicy = () => {
  return (
    <Box sx={{ bgcolor: 'grey.100', minHeight: '100vh', py: 8 }}>
      <Container maxWidth="md">
        <Paper elevation={3} sx={{ p: 6 }}>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
            Privacy Policy
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Last updated: January 1, 2024
          </Typography>
          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
            1. Information We Collect
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            We collect information that you provide directly to us, including when you create an account, 
            make a booking, subscribe to our newsletter, or contact us for support. This information may include:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 3, lineHeight: 2 }}>
            <li>Name and contact information (email address, phone number)</li>
            <li>Booking and travel preferences</li>
            <li>Payment information (processed securely through our payment partners)</li>
            <li>Communication preferences</li>
            <li>Feedback and survey responses</li>
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
            2. How We Use Your Information
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            We use the information we collect to:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 3, lineHeight: 2 }}>
            <li>Process and manage your bookings</li>
            <li>Send booking confirmations and travel documents</li>
            <li>Communicate with you about your bookings and our services</li>
            <li>Provide customer support and respond to your inquiries</li>
            <li>Send marketing communications (with your consent)</li>
            <li>Improve our website and services</li>
            <li>Comply with legal obligations</li>
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
            3. Data Sharing and Disclosure
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            We may share your information with:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 3, lineHeight: 2 }}>
            <li>Travel service providers (airlines, hotels, tour operators) to fulfill your bookings</li>
            <li>Payment processors to handle transactions</li>
            <li>Service providers who assist us in operating our business</li>
            <li>Legal authorities when required by law</li>
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            We do not sell your personal information to third parties.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
            4. Data Security
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            We implement appropriate technical and organizational measures to protect your personal information 
            against unauthorized access, alteration, disclosure, or destruction. This includes encryption, 
            firewalls, and secure server facilities.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
            5. Your Rights
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            You have the right to:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 3, lineHeight: 2 }}>
            <li>Access your personal data</li>
            <li>Correct inaccurate data</li>
            <li>Delete your data (subject to legal requirements)</li>
            <li>Object to processing of your data</li>
            <li>Withdraw consent for marketing communications</li>
            <li>Data portability</li>
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
            6. Cookies and Tracking
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Our website uses cookies and similar tracking technologies to enhance your browsing experience, 
            analyze site traffic, and personalize content. You can control cookie preferences through your 
            browser settings.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
            7. Changes to This Policy
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            We may update this privacy policy from time to time. We will notify you of any changes by posting 
            the new policy on this page and updating the "Last updated" date.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
            8. Contact Us
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            If you have any questions about this privacy policy or our data practices, please contact us at:
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 2 }}>
            Email: {process.env.REACT_APP_EMAILID || 'privacy@travelagency.com'}<br />
            Phone: {process.env.REACT_APP_PHONE_NUMBER || '+91 1234567890'}<br />
            Address: Kolkata, India
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;